import React, { createContext, useState, useRef } from "react";

const contextGeomedellin = createContext([]);

export const GlobalProvider = ({ children }) => {
  const refDivCard = useRef(null);

  const refDivCardOpenData = useRef(null);

  //estados globales usados en geomdellin
  const [caractFiltro, setCaractFiltro] = useState({}); // caracteristicas filtro de busqueda
  const [idComponente, setIdComponente] = useState(); // caracteristicas filtro de busqueda
  const [componentes, setComponentes] = useState([]); // Estado de componente
  const [buscadorHoriBool, setBuscadorHoriBool] = useState(false); // Estado de componente

  // const closePictureInPicture = async () => {
  //   if (window.document.pictureInPictureElement) {
  //     await window.document.exitPictureInPicture();
  //   }
  // };

  const restablecerEstilos = () => {
    document.getElementsByTagName("html")[0].style = "filter: grayscale(0);";
    document.getElementsByTagName("html")[0].style = "filter: grayscale(0);";
    document.getElementsByTagName("html")[0].style = "filter: inherit";

    for (const tagA of document.getElementsByTagName("a")) {
      tagA.style = "text-decoration: none;";
    }
    for (const tagA of document.getElementsByTagName("a")) {
      tagA.style = "font-weight: normal;";

      if (tagA.className === "content-retroceder") {
        tagA.style = "display:none;";
      }

      if (tagA.id === "optionmenu") {
        tagA.style = "font-weight: 700;";
      }
    }
    for (const tagA of document.getElementsByTagName("p")) {
      tagA.style = "font-weight: normal;";
    }
    for (const tagA of document.getElementsByTagName("label")) {
      tagA.style = "font-weight: normal;";

      if (tagA.className === "lbl-titulo-result") {
        tagA.style = "font-weight: 700;";
      }
      if (tagA.className.includes("lbl-opciones-busqueda")) {
        tagA.style = "font-weight: 700;";
      }

      if (tagA.className === "label-ayuda-descripcion") {
        tagA.style = "font-weight: 700;";
      }

      if (tagA.className === "form-check-label") {
        tagA.style = "font-weight: 700;";
      }

      if (tagA.className === "lbl-principal-buscador-vertical") {
        tagA.style = "font-weight: 600;";
      }

      if (tagA.className.includes("check-buscador")) {
        tagA.style = "font-weight: 700;";
      }

      if (tagA.className === "lblitulo-txt-imgbanner") {
        tagA.style = "font-weight: 800;";
      }

      if (tagA.className === "lbl-tarjetas-app") {
        tagA.style = "font-weight: 600;";
      }

      if (tagA.className === "lbl-opendata") {
        tagA.style = "font-weight: 600;";
      }
    }
    for (const tagA of document.getElementsByTagName("span")) {
      tagA.style = "font-weight: normal;";
    }
    for (const tagA of document.getElementsByTagName("h1")) {
      tagA.style = "font-weight: normal;";
    }
    for (const tagA of document.getElementsByTagName("h2")) {
      tagA.style = "font-weight: normal;";
    }
    for (const tagA of document.getElementsByTagName("h3")) {
      tagA.style = "font-weight: normal;";
    }
    for (const tagA of document.getElementsByTagName("h4")) {
      tagA.style = "font-weight: normal;";
    }
    for (const tagA of document.getElementsByTagName("h5")) {
      tagA.style = "font-weight: normal;";
    }
    for (const tagA of document.getElementsByTagName("h6")) {
      tagA.style = "font-weight: normal;";
    }

    document.querySelector(".barra-gov").style = "background-color:#376ac9;";
    document.querySelector(".delete-efectobotones").style = "color:#fff;";
    document.querySelector("#user-or_initSesion").style = "color:#fff;";
  };

  //se retornan los elementos globales de geomdellin
  return (
    <contextGeomedellin.Provider
      value={{
        caractFiltro,
        setCaractFiltro,
        idComponente,
        setIdComponente,
        componentes,
        setComponentes,
        buscadorHoriBool,
        setBuscadorHoriBool,
        restablecerEstilos,
        refDivCard,
        refDivCardOpenData,
      }}
    >
      {children}
    </contextGeomedellin.Provider>
  );
};

export default contextGeomedellin;
